import React, { useContext, createContext } from 'react';
import paths from '../../../../paths';
import { useUser } from '../../../User/containers/UserDataStore';
import makeConnectTo from '../../../util/makeConnectTo';
import { RegistrationTypes } from '../../AnonymousHeader/RegistrationModal/RegistrationEnums';

const RegistrationModal = createContext();

const name = 'accountOrMembershipRequiredModalContext';

export const useAccountOrMembershipRequiredModalContext = () =>
	useContext(RegistrationModal);

export const connectToAccountOrMembershipRequiredModalContext = makeConnectTo(
	RegistrationModal,
	name,
);

export default function AccountOrMembershipRequiredModalContext({ children }) {
	const [isVisible, setIsVisible] = React.useState(false);
	const [pathForRedirect, setPathForRedirect] = React.useState(
		window.location.pathname.includes('reset-password')
			? paths.home()
			: null,
	);
	const [type, setType] = React.useState(RegistrationTypes.SignUp);
	const [community, setCommunity] = React.useState({});
	const { isAnonymous } = useUser();

	const isNonMember = () =>
		Object.keys(community).length > 0 || isAnonymous();

	const accountOrMembershipRequiredModalContext = () => ({
		isVisible,
		pathForRedirect,
		type,
		community,
		setIsVisible,
		setPathForRedirect,
		setType,
		setCommunity,
		isNonMember,
	});

	return (
		<RegistrationModal.Provider
			value={accountOrMembershipRequiredModalContext()}>
			{children}
		</RegistrationModal.Provider>
	);
}
